import { CSSProperties } from 'react';
import Tooltip from '../../juristec-ui/core/Tooltip';
import { BadgeContainer, TooltipText } from './styled/index.styled';
import { VirtualAssistant } from '../../juristec-ui/icons';

export interface GptTokens {
  used: number;
  limit: number;
  bonus: number;
}

interface AssistentTokensBadgeProps {
  gptTokens: GptTokens;
  style?: CSSProperties;
  size?: 'small' | 'medium' | 'large';
}

const formatter = new Intl.NumberFormat('pt-BR', {
  notation: 'compact',
  compactDisplay: 'short',
});

const TooltipContent = () => (
  <TooltipText>
    Tokens disponíveis do assistente
  </TooltipText>
);

const getColor = (gptTokens: GptTokens) => {
  if (gptTokens.used < gptTokens.limit) return 'success';
  if (gptTokens.bonus > 0) return 'warning';
  return 'error';
};

const AssistentTokensBadge = ({
  gptTokens, style, size = 'medium',
}: AssistentTokensBadgeProps) => (
  <Tooltip text={<TooltipContent />} direction="bottom">
    <BadgeContainer
      color={getColor(gptTokens)}
      size={size}
      style={style}
    >
      <VirtualAssistant />
      <span>
        {formatter.format(
          Math.max(
            gptTokens.bonus + gptTokens.limit - Math.min(gptTokens.used, gptTokens.limit),
            0,
          ),
        )}
      </span>
    </BadgeContainer>
  </Tooltip>
);

export default AssistentTokensBadge;
